import React from 'react';
import Button from '@/components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './TablePagination.module.scss';
import t from '@/utils/Language/UI-translations';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';

const TablePagination = ({ pagination, onPageChange, containerClass }) => {
  return (
    <ButtonGroup className={`${classes.paginationButtonGroup} ${containerClass}`}>
      <Button
        data-cy="pagination-button-left"
        type={'secondary'}
        additionalClasses={classes.paginationLeftButton}
        disabled={pagination.page === pagination.total_pages}
        onButtonClick={typeof onPageChange === 'function' ? () => onPageChange(pagination.page + 1) : null}
      >
        <span>
          <FontAwesomeIcon icon={['fas', 'caret-right']} />
        </span>
      </Button>

      <DropdownButton
        data-cy="pagination-button-center"
        as={ButtonGroup}
        title={t('Page') + ` ${pagination.page} ` + t('of') + ` ${pagination.total_pages}`}
        className={classes.paginationCenterButton}
      >
        {[...Array(pagination.total_pages + 1).keys()].map((page, index) => {
          return (
            <React.Fragment key={index}>
              {page !== 0 && (
                <Dropdown.Item
                  eventKey={page}
                  key={index}
                  className={[classes.paginationDropDownItem, pagination.page === page ? classes.selectedPagination : ''].join(' ')}
                  onClick={typeof onPageChange === 'function' ? () => onPageChange(page) : null}
                >{`Page ${page} of ${pagination.total_pages}`}</Dropdown.Item>
              )}
            </React.Fragment>
          );
        })}
      </DropdownButton>

      <Button
        data-cy="pagination-button-right"
        type={'secondary'}
        additionalClasses={classes.paginationRightButton}
        disabled={pagination.page === 1}
        onButtonClick={typeof onPageChange === 'function' ? () => onPageChange(pagination.page - 1) : null}
      >
        <span>
          <FontAwesomeIcon icon={['fas', 'caret-left']} />
        </span>
      </Button>
    </ButtonGroup>
  );
};

export default TablePagination;
